const runtimeConfig = typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__ || {} : {};

function isTemplatePlaceholder(value) {
  return typeof value === 'string' && /^\$\{[A-Z0-9_]+\}$/.test(value.trim());
}

export function getEnv(key, fallback = '') {
  const runtimeValue = runtimeConfig[key];
  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '' && !isTemplatePlaceholder(runtimeValue)) {
    return runtimeValue;
  }

  const buildValue = process.env[key];
  if (buildValue !== undefined && buildValue !== null && buildValue !== '') {
    return buildValue;
  }

  return fallback;
}

export function getEnvNumber(key, fallback) {
  const value = Number(getEnv(key, ''));
  return Number.isFinite(value) ? value : fallback;
}

export function getEnvBoolean(key, fallback = false) {
  const value = getEnv(key, '').toString().trim().toLowerCase();

  if (value === 'true' || value === '1') return true;
  if (value === 'false' || value === '0') return false;

  return fallback;
}